import { KeyboardBackground } from './components/KeyboardBackground';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ProjectsSection } from './components/ProjectsSection';
import { SkillsSection } from './components/SkillsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { ParallaxSpacer } from './components/ParallaxSpacer';
import { Analytics } from '@vercel/analytics/react';

export function App() {
  return (
    <div className="relative min-h-screen bg-dark text-white overflow-x-hidden">
      {/* 3D Keyboard assembly background - fixed layer */}
      <KeyboardBackground />

      {/* Content wrapper - above video */}
      <div className="relative z-10">
        {/* Fixed navbar */}
        <Navbar />

        {/* Main content */}
        <main>
          {/* Hero Section */}
          <HeroSection />

          {/* Parallax spacer with floating dots */}
          <ParallaxSpacer height="15vh" variant="dots" intensity={1.2} />

          {/* About Section */}
          <AboutSection />

          {/* Parallax spacer with lines */}
          <ParallaxSpacer height="10vh" variant="lines" intensity={0.8} />

          {/* Skills Section */}
          <SkillsSection />

          {/* Parallax spacer with minimal shapes */}
          <ParallaxSpacer height="10vh" variant="minimal" intensity={1} />

          {/* Projects Section */}
          <ProjectsSection />

          {/* Parallax spacer with waves */}
          <ParallaxSpacer height="10vh" variant="waves" intensity={0.6} />

          {/* Contact Section */}
          <ContactSection />
        </main>

        {/* Footer */}
        <Footer />
      </div>

      {/* Vercel Analytics */}
      <Analytics />
    </div>
  );
}
